import React, { useState } from "react";

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { TextField, Button } from '@material-ui/core';
import { useForm, Controller } from "react-hook-form";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { useHistory } from "react-router-dom";

import submitData from '../submitData';

const useStyles = makeStyles((theme) => ({
    formControlLabel: {
        fontSize: 16,
        color: '#4A4A4A',
        padding: theme.spacing(0, 0, 1, 0)
    },

}));

const Conditions = ({ NextButton, handleData, data, saveChangesState, isEdit, dispatch }: any) => {
    const { trigger, getValues, control, setValue, errors } = useForm();
    const history = useHistory();

    const handleNext = async (data: any): Promise<void> => {
        handleData(data);
    }


    const saveChanges = async (update = false) => {
        const isValid = await trigger();
        if (isValid) {
            let dataPass = {
                patientMedicalConditions: getValues('PatientMedicalConditions')
            }
            handleData(dataPass);
            if (update == true) submitData({ ...data, ...dataPass }, dispatch, history)
        }
        return isValid;
    }

    React.useEffect(() => {
        saveChangesState[1](() => saveChanges);
    }, [data])

    React.useEffect(() => {
        setValue("PatientMedicalConditions", data.PatientMedicalConditions || data.patientMedicalConditions || "");
    }, [data])

    const onNextButtonClick = async (): Promise<boolean> => {
        const isValid = await trigger();
        if (isValid) {
            let dataPass = {
                PatientMedicalConditions: getValues('PatientMedicalConditions')
            }
            await handleNext(dataPass);
        }
        return isValid;
    }

    return (
        <React.Fragment >
            <Grid container style={{paddingTop:40}} alignItems="flex-start">

                <Grid container item alignItems="flex-start">
                    <Grid item xs={6}>
                        <Typography style={{ fontSize: 36, fontWeight: 900, }}>
                            Medical Conditions</Typography>
                    </Grid>
                    <Grid item xs={6} style={{ textAlign: 'right' }}>
                        {!isEdit && <NextButton onClick={onNextButtonClick} />}
                        <Button id="update_changes" style={{ display: "none" }} onClick={() => saveChanges(true)}></Button>
                        <Button id="save_changes" style={{ display: "none" }} onClick={() => saveChanges(false)}></Button>
                    </Grid>

                    <Grid alignItems="flex-start" item xs={12} style={{ paddingTop: 20 }}>
                        <Controller
                            name='PatientMedicalConditions'
                            defaultValue=''
                            control={control}
                            as={<TextField
                                placeholder="Required"
                                multiline
                                error={errors.PatientMedicalConditions}
                                helperText={errors.PatientMedicalConditions ? errors.PatientMedicalConditions.message : ""}
                                variant="outlined"
                                InputProps={{
                                    style: {
                                        height: 310,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'flex-start',
                                    }
                                }}
                            />
                            }
                            rules={{
                                required: "Medical conditions is required",
                            }}
                        />
                    </Grid>

                </Grid>
            </Grid>
        </React.Fragment >
    );
}

export default Conditions;